/// <reference path="controls.module.ts" />
/// <reference path="monthYearRangePicker.ts" />

module Meevo.Components.Controls {
    export class MeevoMonthYearPicker implements angular.IDirective {
        restrict = "E";
        scope = {
            selectedDate: "=ngModel",
            disabled: '=ngDisabled',
            required: '=ngRequired',
            runReportFor: '@?',
            limitDateRangeTo: '@?',
            minDate: '=?',
            maxDate: '=?',
            timeZoneOffset: '=?',
        };

        templateUrl = "app/components/controls/monthYearPickerTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            const dateLimits = getDateLimits(scope);
            scope.timeRangeAmount = dateLimits.timeRangeAmount;
            scope.timeRangeLabel = dateLimits.timeRangeLabel;
            const minDate = dateLimits.minDate;
            const maxDate = dateLimits.maxDate;

            scope.maxDate = maxDate || scope.maxDate || moment().add(100, 'years').toDate();
            scope.minDate = minDate || scope.minDate || moment().subtract(100, 'years').toDate();

            const maxYear = moment(scope.maxDate).year();
            const minYear = moment(scope.minDate).year();
            scope.yearList = _.range(maxYear, minYear - 1, -1);

            const maxMonth = moment(scope.maxDate).month();
            const minMonth = moment(scope.minDate).month();

            var months = _.range(1, 13);
            scope.monthList = _.map(months, (month: any) => ({
                index: month,
                label: moment(month, 'M').format('MMMM'),
                isDisabled: false,
            }));

            scope.change = () => {
                if (scope.yearModel === maxYear) {
                    scope.monthList.forEach(month => month.isDisabled = month.index > maxMonth + 1);
                    if (scope.monthList[scope.monthModel - 1].isDisabled) {
                        scope.monthModel = maxMonth + 1;
                    }
                } else if (scope.yearModel === minYear) {
                    scope.monthList.forEach(month => month.isDisabled = month.index < minMonth + 1);
                    if (scope.monthList[scope.monthModel - 1].isDisabled) {
                        scope.monthModel = minMonth + 1;
                    }
                } else {
                    scope.monthList.forEach(month => month.isDisabled = false)
                }

                //scope.monthmodel -1 is due to moment using a 0 based month for input
                scope.selectedDate = moment().set("month", scope.monthModel - 1)
                                             .set("year", scope.yearModel)
                                             .startOf('month').toDate();
            }

            let defaultDate = moment().toDate();
            if (scope.selectedDate) {
                defaultDate = scope.selectedDate;
            } else {
                if (scope.maxDate  < defaultDate) {
                    defaultDate = scope.maxDate;
                } else if (scope.minDate > defaultDate) {
                    defaultDate = scope.minDate;
                }
            }
            scope.monthModel = moment(defaultDate).month() + 1;
            scope.yearModel = moment(defaultDate).year();
            scope.change();
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoMonthYearPicker();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoMonthYearPicker", MeevoMonthYearPicker.factory());
}
